export const NUM_OF_MODELS_SKELETONS = 4
